import mitt, { Emitter } from 'mitt';

// 定义事件类型（键为事件名，值为事件参数类型）
type Events = {
  'refresh-order-tabel': { data: boolean };
};

const emitter: Emitter<Events> = mitt<Events>();
export default emitter;
